import http from '../../http-common';

/**
 * @author André
 * 09/08/2022
 **/

const url = '/Autocomplete/';

export const PrinterClientAutocompleteService = {
    GetPrinterClient(params) {
        return http.get(`${url}PrinterClient`, { params });
    },
};
